import Swiper from 'swiper';
import { Autoplay, Mousewheel, Navigation, Pagination } from 'swiper/modules';
import { mountNews } from './components/News';
import { run, setImgs, updateWishlistArea } from './main';
import 'swiper/swiper-bundle.css';

run(Swiper, { Autoplay, Mousewheel, Navigation, Pagination });
mountNews(document.querySelector('.news-container'));
setImgs();
updateWishlistArea();
